var Constants = require('../constants/Constants');
var BaseStore = require('./BaseStore');

var ClientStore = new BaseStore();

ClientStore.register(Constants.auth_api.AUTH, function (payload) {
    var action = payload.action

    if (action.state === Constants.request.FINISHED) {
        const rels = (ClientStore._data.relationshipInvites || [])
          .filter(i => i.email !== action.response.body.email)
        rels.push(action.response.body)

        ClientStore._data.relationshipInvites = rels

        return true;
    }
})

ClientStore.register(Constants.auth_api.DEAUTH, function (payload) {
    var action = payload.action

    if (action.state === Constants.request.FINISHED) {
        const filteredInvites = ClientStore._data.relationshipInvites.filter(
          i => i.email !== action.params.username
        )
        ClientStore._data.relationshipInvites = filteredInvites

        return true;
    }
})

ClientStore.register(Constants.api.GET_SERVICES, function (payload) {
    var action = payload.action;

    if (action.state === Constants.request.PENDING) {
        this._loading = true;

        return true;
    }

    if (action.state === Constants.request.FINISHED) {
        this._loading = false;
        this.setData(action.response.body.client);

        return true;
    }
});
module.exports = ClientStore;



// WEBPACK FOOTER //
// ./app/stores/ClientStore.js